import {GlobalStyles} from '@mui/material';
import React from 'react';

const styles = theme => ({
  '@supports (scrollbar-color: auto)': {
    '*': {
      scrollbarColor: `color-mix(in srgb, ${theme.vars.palette.background.paper}, white 25%) ${theme.vars.palette.background.paper}`,
      scrollbarWidth: 'thin',
      ...theme.applyStyles('light', {
        scrollbarColor: `color-mix(in srgb, ${theme.vars.palette.background.paper}, black 25%) ${theme.vars.palette.background.paper}`,
      }),
    },
  },
  '@supports selector(::-webkit-scrollbar)': {
    '*::-webkit-scrollbar': {
      width: 11,
    },
    '*::-webkit-scrollbar-track': {
      background: theme.vars.palette.background.paper,
    },
    '*::-webkit-scrollbar-thumb': {
      background: `color-mix(in srgb, ${theme.vars.palette.background.paper}, white 25%)`,
      borderRadius: 11,
      border: '2px solid',
      borderColor: theme.vars.palette.background.paper,
      ...theme.applyStyles('light', {
        background: `color-mix(in srgb, ${theme.vars.palette.background.paper}, black 25%)`,
      }),
    },
  },
  'html, body': {
    fontFamily: theme.typography.fontFamily,
    height: '100%',
  },
  '#root': {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  // style for shift-drag-zoom
  '.ol-box': {
    background: (theme.vars || theme).palette.common.white,
    border: `1px dashed ${(theme.vars || theme).palette.primary.dark}`,
    boxSizing: 'border-box',
    opacity: 0.4,
  },
  a: {
    cursor: 'pointer',
    userDrag: 'none',
    WebkitUserDrag: 'none', //chrome
    MozUserDrag: 'none', //firefox
  },
  img: {
    userDrag: 'none',
    WebkitUserDrag: 'none', //chrome
    MozUserDrag: 'none', //firefox
  },
  '.sentry-error-embed-wrapper': {
    '& .btn': {
      background: `${(theme.vars || theme).palette.primary.main} !important`,
      border: `1px solid ${(theme.vars || theme).palette.primary.main} !important`,
      borderRadius: (theme.vars || theme).shape.borderRadius,
    },
  },
  ':root': {
    //Toastify overrides see https://fkhadra.github.io/react-toastify/how-to-style#override-css-variables
    '--toastify-color-info': 'var(--mui-palette-Alert-infoFilledBg)',
    '--toastify-color-success': 'var(--mui-palette-Alert-successFilledBg)',
    '--toastify-color-warning': 'var(--mui-palette-Alert-warningFilledBg)',
    '--toastify-color-error': 'var(--mui-palette-Alert-errorFilledBg)',
    '--toastify-toast-bd-radius': (theme.vars || theme).shape.borderRadius,
    '--toastify-toast-min-height': 0,
    '--toastify-toast-padding': theme.spacing(1, 2),
  },
});

const appGlobalStyles = <GlobalStyles styles={styles} />;

export default appGlobalStyles;
